import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Divider,
    Snackbar,
    TextField,
    Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel"; // Importing carousel for the slider
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import carousel styles
import { useNavigate, useParams } from "react-router-dom";
import { API_LoginURL, Img_APIURL } from "../../../config";
import Navbar from "../../Header/header";
import SideBar from "./TeacherSidebar/TeacherSidebar";

const ProjectDetail = () => {
    // const { id } = useParams(); // Get project ID from the URL
    const [id] = useState(() =>
        sessionStorage.getItem("teacherProjectApprovalId")
    );
    const [submittedProjects, setSubmittedProjects] = useState([]); // All projects
    const [project, setProject] = useState(null); // Specific project to display
    const [loading, setLoading] = useState(true); // Loading state
    const [error, setError] = useState(null); // Error handling
    const [projectFeedback, setComment] = useState("");
    const [snackbarOpen, setSnackbarOpen] = useState(false); // Snackbar state
    const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
    const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Snackbar severity (success/error)
    const navigate = useNavigate();

    useEffect(() => {
        fetchSubmittedProjects();
    }, []);

    const fetchSubmittedProjects = async () => {
        try {
            const response = await axios.get(
                `${API_LoginURL}project/ProjectSubmissionListById`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: localStorage.getItem("token"),
                    },
                }
            );
            setSubmittedProjects(response.data); // Store all submitted projects
        } catch (error) {
            console.error("Error fetching submitted projects:", error);
            setError("Error fetching projects");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (submittedProjects.length > 0) {
            const foundProject = submittedProjects.find(
                (project) => project.projectSubmissionId.toString() === id
            );
            setProject(foundProject);
        }
    }, [submittedProjects, id]);

    if (loading) {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return <Typography>{error}</Typography>;
    }

    if (!project) {
        return <Typography>No project found with this ID</Typography>;
    }

    const handleApproval = async (projectStatus) => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                setError("Unauthorized: Please log in again.");
                return;
            }

            const response = await axios.post(
                `${API_LoginURL}project/ProjectApprove`,
                {
                    projectSubmissionId: parseInt(id),
                    projectStatus, // "Approved" or "Rejected"
                    projectFeedback,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: localStorage.getItem("token"),
                    },
                }
            );

            if (response.status === 200) {
                setSnackbarMessage(`Project ${projectStatus} successfully!`);
                setSnackbarSeverity("success");
                setSnackbarOpen(true);
                navigate("/TeacherProjects"); // Go back to projects table
            } else {
                console.error("Error updating project:", response);
                setSnackbarMessage("Error updating project status.");
                setSnackbarSeverity("error");
                setSnackbarOpen(true);
            }
        } catch (error) {
            console.error("Error updating project:", error);
            setSnackbarMessage("Error updating project status.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        }
    };

    const handleDownload = (filePath) => {
        const link = document.createElement("a");
        link.href = filePath;
        link.download = filePath.split("/").pop(); // Extract file name from path for download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const renderDocumentViewer = (filePath) => {
        if (filePath.endsWith(".pdf")) {
            return (
                <iframe
                    src={filePath}
                    width="100%"
                    height="500px"
                    title="PDF Document"
                />
            );
        } else if (filePath.endsWith(".txt")) {
            return (
                <pre>
                    {`Document content is not displayed here for text files.`}
                </pre>
            );
        } else {
            return (
                <Typography>
                    No document viewer available for this file type.
                </Typography>
            );
        }
    };

    return (
        <div className="container-scroller">
            <Navbar />
            <div className="container-fluid page-body-wrapper">
                <SideBar />
                <div className="main-panel">
                    <Box
                        sx={{
                            height: "calc(100vh - 60px)",
                            padding: "20px",
                            backgroundColor: "#F8F9FD",
                            overflowY: "scroll",
                        }}
                    >
                        <div className="card">
                            <div className="card-body">
                                <div style={{ padding: "20px" }}>
                                    {/* Project Details Section */}
                                    <div style={{ marginBottom: "20px" }}>
                                        <Typography variant="h4" sx={{ mb: 2 }}>
                                            {project.projectName}
                                        </Typography>
                                        <Divider sx={{ mb: 3 }} />
                                        <Card sx={{ mb: 3 }}>
                                            <CardContent>
                                                <Typography
                                                    variant="h6"
                                                    sx={{ mb: 2 }}
                                                >
                                                    Summary:
                                                </Typography>
                                                <Typography variant="body1">
                                                    {project.projectSummary}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </div>

                                    {/* Media Files Section */}
                                    <Card sx={{ mb: 3 }}>
                                        <CardContent>
                                            <Typography
                                                variant="h6"
                                                sx={{ mb: 2 }}
                                            >
                                                Media:
                                            </Typography>
                                            <Box>
                                                {project.mediaFiles &&
                                                project.mediaFiles.length >
                                                    0 ? (
                                                    <Carousel>
                                                        {project.mediaFiles.map(
                                                            (media, index) => (
                                                                <div
                                                                    key={index}
                                                                >
                                                                    {media.projectMediaPath?.endsWith(
                                                                        ".mp4"
                                                                    ) ? (
                                                                        <video
                                                                            src={
                                                                                Img_APIURL +
                                                                                project
                                                                                    .mediaFiles[0]
                                                                                    .projectMediaPath
                                                                            }
                                                                            style={{
                                                                                width: "100%",
                                                                                height: "100%",
                                                                                objectFit:
                                                                                    "cover",
                                                                            }}
                                                                            controls
                                                                            autoPlay
                                                                        />
                                                                    ) : (
                                                                        <img
                                                                            src={
                                                                                media.projectMediaPath
                                                                                    ? Img_APIURL +
                                                                                      project
                                                                                          .mediaFiles[0]
                                                                                          .projectMediaPath
                                                                                    : "https://via.placeholder.com/100"
                                                                            }
                                                                            alt="Thumbnail"
                                                                            style={{
                                                                                width: "100%",
                                                                                height: "100%",
                                                                                objectFit:
                                                                                    "cover",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                            )
                                                        )}
                                                    </Carousel>
                                                ) : (
                                                    <Typography>
                                                        No media files available
                                                    </Typography>
                                                )}
                                            </Box>
                                        </CardContent>
                                    </Card>

                                    {/* Submitted Documents Section */}
                                    <Card sx={{ mb: 3 }}>
                                        <CardContent>
                                            <Typography
                                                variant="h6"
                                                sx={{ mb: 2 }}
                                            >
                                                Submitted Documents:
                                            </Typography>
                                            <Box>
                                                {project.mediaFiles.map(
                                                    (media, index) => (
                                                        <Box
                                                            key={index}
                                                            sx={{ mb: 2 }}
                                                        >
                                                            <Typography
                                                                variant="body1"
                                                                sx={{
                                                                    mb: 1,
                                                                }}
                                                            >
                                                                Document{" "}
                                                                {index + 1}:{" "}
                                                                {media.projectFilePath
                                                                    .split("/")
                                                                    .pop()}
                                                            </Typography>
                                                            {media.projectFilePath &&
                                                                renderDocumentViewer(
                                                                    Img_APIURL +
                                                                        project
                                                                            .mediaFiles[0]
                                                                            .projectFilePath
                                                                )}
                                                            <Button
                                                                variant="contained"
                                                                sx={{
                                                                    mt: 2,
                                                                }}
                                                                onClick={() =>
                                                                    handleDownload(
                                                                        media.projectFilePath
                                                                    )
                                                                }
                                                            >
                                                                Download
                                                                Document
                                                            </Button>
                                                        </Box>
                                                    )
                                                )}
                                            </Box>
                                        </CardContent>
                                    </Card>

                                    {/* Submission Date Section */}
                                    <Card>
                                        <CardContent>
                                            <Typography
                                                variant="h6"
                                                sx={{ mb: 2 }}
                                            >
                                                Submission Date:
                                            </Typography>
                                            <Typography variant="body1">
                                                {project.projectSubmissionDate}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </div>

                                {/* Comments Section */}
                                <TextField
                                    fullWidth
                                    label="Comments"
                                    multiline
                                    rows={3}
                                    value={projectFeedback}
                                    onChange={(e) => setComment(e.target.value)}
                                    variant="outlined"
                                    sx={{ mb: 2 }}
                                />

                                {/* Approval Buttons */}
                                <Box display="flex" gap={2}>
                                    <Button
                                        variant="contained"
                                        color="success"
                                        onClick={() =>
                                            handleApproval("Approved")
                                        }
                                    >
                                        Approve
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="error"
                                        onClick={() =>
                                            handleApproval("Rejected")
                                        }
                                    >
                                        Reject
                                    </Button>
                                </Box>
                            </div>
                        </div>
                    </Box>
                </div>
            </div>

            {/* Snackbar for Notifications */}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={() => setSnackbarOpen(false)}
            >
                <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity={snackbarSeverity}
                    sx={{ width: "100%" }}
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default ProjectDetail;
